import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardPercentageIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 5.13672L5 19.1367M9 7.13672C9 8.24129 8.10457 9.13672 7 9.13672C5.89543 9.13672 5 8.24129 5 7.13672C5 6.03215 5.89543 5.13672 7 5.13672C8.10457 5.13672 9 6.03215 9 7.13672ZM19 17.1367C19 18.2413 18.1046 19.1367 17 19.1367C15.8954 19.1367 15 18.2413 15 17.1367C15 16.0321 15.8954 15.1367 17 15.1367C18.1046 15.1367 19 16.0321 19 17.1367Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardPercentageIcon;
